export const LOCAL_STORAGE_OIDC_CONFIG_NAME = "cora.oidc.config";
export const LOCAL_STORAGE_RELOAD_FLAG = "cora.reload";
export const SESSION_STORAGE_SURVEY_ID = "cora.surveyId";